import { styled } from '@mui/material/styles';

import Badge from '@mui/material/Badge';

export const BadgePulse = styled(Badge)<{
  top?: number;
  right?: number;
}>`
  .MuiBadge-badge {
    border-radius: 6px;
    font-size: 0.8rem;
    animation: pulse-black 2s infinite;
    ${(p) => p.top && `top: ${p.top}px`};
    ${(p) => p.right && `right: ${p.right}px`};
  }

  @keyframes pulse-black {
    0% {
      box-shadow: 0 0 0 0 ${(p) => p.theme.palette.secondary.main}90;
    }

    70% {
      box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
`;
